<template>
  <div 
    class="balloonTemplateData" 
    :class="(templateData.length != 0) ? 'active' : null " 
    :style="[ movePostion ]"
  >
    <p class="balloon">템플릿을 삽입할 위치를 클릭하여 주세요.</p>
  </div>
</template>


<script>
import { commNewMapGetters , commNewMapMutations , commNewMapActions } from "@processEditor/CommNew";
export default {
  data () {
    return {
      x : 0 , 
      y : 0 , 
    }
  } , 
  computed : {
    ...commNewMapGetters([
      'crntPos' , 
      'templateData' , 
    ]) , 
    movePostion () {
      return {
        left : `${ this.x }px` , 
        top : `${ this.y }px` , 
      }
    } , 
  } , 
  watch : {
    templateData ( templateData ) {
      if ( templateData.length != 0 ) {
        this.x = this.crntPos.x ; 
        this.y = this.crntPos.y ; 
        window.addEventListener( 'mousemove' , this.moveHandler ) ; 
        window.addEventListener( 'click' , this.clickHandler ) ; 
      }
    } , 
  } , 
  mounted () {
  } , 
  methods : {
    ...commNewMapActions([
      'setTemplateData' , 
      'setTemplateLNBInfo' , 
      'setTemplateDiagramInfo' , 
    ]) , 
    ...commNewMapMutations([
      'setCrntPos' , 
    ]) , 
    moveHandler ( e ) {
      this.x = e.pageX ; 
      this.y = e.pageY ; 
    } , 
    clickHandler ( e ) {
      this.setCrntPos({ x : e.pageX , y : e.pageY }) ; 
      this.setTemplateLNBInfo() ; 
      this.setTemplateDiagramInfo() ; 
      this.setTemplateData([]) ; 

      window.removeEventListener( 'mousemove' , this.moveHandler ) ; 
      window.removeEventListener( 'click' , this.clickHandler ) ; 
    } , 
  }
}
</script>

<style lang="scss" scoped>
  .balloonTemplateData {
    position: fixed; 
    left: 50%; top: 50%; 
    visibility: hidden; 
    background-color: $black; 
    width: 6px; height: 6px; 
    border-radius: 50%; 
    transform: translate( -50% , -50% ); 

    .balloon {
      display: flex; 
      width: 180px; height: 70px; 
      background-color: $white; 
      padding: 4px 20px; 
      border-radius: 10px; 
      box-shadow: 0 0 10px rgba( 0,0,0,0.4); 
      line-height: 1.4; 
      border-radius: 30px; 
      align-items: center; 
      justify-content: center; 
      transform: translateX( -50% ) translateY( -86px ); 
      filter: drop-shadow(0px 0px 10px rgba( 0,0,0,0.4));

      &::before {
        content: ''; 
        display: flex; 
        width: 10px; height: 10px; 
        background-color: $white;
        position: absolute; 
        left: 50%; bottom: -8px; 
        transform: rotate( 45deg ) translateX( -50% ); 
      }
      
      font-size: 14px; 
      @include text-prt-m; 
    }
    &.active {
      visibility: visible; 
    }
  } 
</style>